import {map} from 'lodash';

import {CountPercentParams} from './PieChart.types';
import {GetFormattedItemsForPieParams} from './PieChart.types';

export const getFormattedItemsForPie = ({
  data,
  total,
}: GetFormattedItemsForPieParams) => {
  const amounts = map(data, 'bonusAmount');
  return amounts.map((amount: any) => {
    const percent = countPercent({value: amount, total});
    return percent < 1 ? 1 : percent;
  });
};

export const countPercent = ({value, total}: CountPercentParams) =>
  +((value / total) * 100).toFixed(2);
